import {
  AfterSubmitFunc,
  FormTemplate,
  SimpleBlock,
  Text,
  useFormContext
} from 'ui-builder';
import { FileDto, FileType, ProjectDocument, useProjectDocumentsService } from 'nekst-api';
import { FileUploaderInput } from 'features/nekst-widgets';
import React from 'react';

type UploadDocumentFormData = { fileId: number, _labelName: string, _file?: FileDto };

function LabelName() {
  const formContext = useFormContext<UploadDocumentFormData>();

  const labelName = formContext.data?._labelName;

  if (labelName) {
    return (
      <SimpleBlock style={{ flexDirection: 'row' }}>
        <Text bold>Label:</Text>
        <Text>
          {' '}
          {labelName}
        </Text>
      </SimpleBlock>
    );
  } else {
    return null;
  }
}

export function UploadDocumentForm(props: {
  data: ProjectDocument,
  afterSubmitFunc?: AfterSubmitFunc,
}) {
  const documentService = useProjectDocumentsService();
  return (
    <FormTemplate<UploadDocumentFormData>
      title="Upload Document"
      submitFormFunc={async (data) => {
        await documentService.setFile(props.data.id, data.fileId);
        return data;
      }}
      afterSubmitFunc={props.afterSubmitFunc}
      initialData={{
        _labelName: props.data._label?.name,
        _file: props.data._file,
      } as UploadDocumentFormData}
    >
      <LabelName />
      <FileUploaderInput
        fileType={FileType.PROJECT_DOCUMENT}
        fileDataSource="_file"
        source="fileId"
        label="Document File"
      />
    </FormTemplate>
  );
}
